export enum ChartType {
  CEOCompensation = 'ceo-compensation',
  CurrentDividendPayout = 'current-dividend-payout',
  DCF = 'dcf',
  DebtEquityHistoryAnalysis = 'debt-equity-history-analysis',
  EarningsAndRevenueGrowth = 'earnings-and-revenue-growth',
  EarningsAndRevenueHistory = 'earnings-and-revenue-history',
  EarningsPerShareGrowth = 'earnings-per-share-growth',
  FinancialPositionAnalysis = 'financial-position-analysis',
  FutureDividendPayout = 'future-dividend-payout',
  FutureGrowth = 'future-growth',
  FutureROE = 'future-roe',
  HistoricDividend = 'historic-dividend',
  InsiderTradingVolume = 'insider-trading-volume',
  OwnershipBreakdown = 'ownership-breakdown',
  PastEarningsGrowth = 'past-earnings-growth',
  PB = 'pb',
  PE = 'pe',
  PEG = 'peg',
  ROE = 'roe',
  ROCE = 'roce',
}

export const COMPANY_PAST_PERFORMANCE = 'last-perf';
export const PORTFOLIO_DOWNLOAD_RETURNS_CONTRIBUTOR = 'returns-contributors';
export const PORTFOLIO_DOWNLOAD_DIVERSIFICATION_COMPANY =
  'diversification-company';
export const PORTFOLIO_DOWNLOAD_DIVERSIFICATION_INDUSTRY =
  'diversification-industry';
export const PORTFOLIO_DOWNLOAD_INTRINSIC_VALUE = 'intrinsic-value-export';
export const PORTFOLIO_DOWNLOAD_PE_PEG_GAUGE = 'PE-PEG-gauge';
export const PORTFOLIO_DOWNLOAD_FUTURE_GROWTH = 'future-growth';
export const PORTFOLIO_DOWNLOAD_PAST_PERFORMANCE = 'last-perf';
